
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { ObjectType, SportType } from '@/@types/graphql-types';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { SnowplowSportContext } from '@/helpers/tracking/providers';

@Component({ name: 'SportHeader' })
export default class SportHeader extends Vue {
	@Prop() path: string;
	@Prop({ default: false }) isIcon: boolean;
	@Prop({ required: true }) sportType: SportType;

	handleClick(location: 'sport' | 'text') {
		const sportContext = new SnowplowSportContext(this.sportType, ObjectType.Sport);
		switch (location) {
			// SPORT ICON
			case 'sport':
				TrackingHelper.trackEvent(
					'userinteraction',
					{
						action: 'sport_clicked',
						property: 'module',
					},
					[sportContext]
				);
				break;

			// MORE DETAILS TEXT
			case 'text':
				TrackingHelper.trackEvent('userinteraction', { action: 'all_matches_clicked' }, [sportContext]);
				break;
		}
	}
}
